export interface GxpCustomUIParams {
    channelType: string;
    dealerCode: string;
    isAuth: boolean;
}
type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>;
type DefaultValues = Pick<GxpCustomUIParams, 'channelType'>;
const defaultGxpCustomUIValues: DefaultValues = {
    channelType: 'OWNERWEB',
};
export type GxpCustomUIWithDefaultsOptional = Optional<
    GxpCustomUIParams,
    keyof DefaultValues
>;
const newGxpCustomUIParams: GxpCustomUIWithDefaultsOptional = {
    dealerCode: '',
    isAuth: false,
};
export const gxpCustomUIActionParams: GxpCustomUIParams = {
    ...defaultGxpCustomUIValues,
    ...newGxpCustomUIParams,
};
